import React, { useEffect, useMemo, useRef, useState } from "react";
import { host, Nav as NavApi, Common } from "@Api";
import { useHover, useLocalStorageState, useMount, useSessionStorageState } from "ahooks";
import ArticlePopover from "@Components/newNav/articlePopover";
import MoviePopover from "@Components/newNav/moviePopover";
import { fetchOnline } from "@Services/api";
import { useAtom } from "jotai";
import { initTracking } from "@Lib/jotai/tracking";
import AppPopover from "../newNav/appPopover";
import HelpPopover from "../newNav/helpPopover";
import UserPopover from "../newNav/userPopover";
import SearchPopover from "../newNav/searchPopover";
import { pkComparisonAtom } from "@Lib/jotai/pkCompare";

const { fetchSearchRecommend } = NavApi;
const { c, www } = host;
const { postInitialCollect } = Common;

function activeNav(setActive) {
  const pathname = location.pathname;
  if (/^c\.(.*)8891\.com\.tw$/.test(location.hostname)) {
    if (window.page_route === "newCar:buyCar" || window.page_route === "newCar:buycar") {
      setActive(1);
    } else if (window.page_route === "newCar:Models") {
      setActive(0);
    } else if (window.page_route === "newCar:movies") {
      setActive(3);
    } else if (/^\/photoModel-(ratingCompare|compare).html/.test(pathname)) {
      setActive(4);
    } else if (window.page_route === `newCar:Articles`) {
      setActive(2);
    } else if (["newCar:menu/{brand}", "newCar:menu", "newCar:menu/{brand}/{kind}"].includes(window.page_route)) {
      setActive(6);
    } else if (window.page_route === "newCar:sales/top") {
      setActive(5);
    }
  }
}

const SinglePageNav: React.FC<{ defaultActive?: number }> = ({ defaultActive }) => {
  const [active, setActive] = useState(defaultActive || -1);
  const articleRef = useRef<any>(null);
  const movieRef = useRef<any>(null);
  const [onlineData, setOnlineData] = useSessionStorageState<any>("oneline-newcar", {
    defaultValue: { onlineCount: 0, modelCount: 0 },
  });
  const [tracking] = useAtom(initTracking);
  const [articleHovered, updateArticleHovered] = useState(false);
  const [movieHovered, updateMovieHovered] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [keyword, setKeyword] = useState<any>([]);
  const def = useRef({});
  const isHoveringArticle = useHover(articleRef);
  const isHoveringMovie = useHover(movieRef);
  const [globalPkList] = useAtom(pkComparisonAtom);

  const [placeholder, setPlaceholder] = useState("");

  const fetchKeyword = async () => {
    try {
      const res = await fetchSearchRecommend({ ads: 1 });
      if (res && res.status === 12000) {
        setKeyword(res.data.default);
        Array.isArray(res.data.default) && !!res.data.default.length &&
          res.data.default.forEach((item) => {
            item.ads && postInitialCollect(item.ads, "show");
          });
      }
    } catch (e) { }
  };

  const getOnlineData = async () => {
    const res = await fetchOnline();
    if (res.status === 12000) {
      setOnlineData({ ...res.data });
    }
  };

  useEffect(() => {
    fetchKeyword();
  }, []);

  useEffect(() => {
    if (isHoveringArticle) {
      updateArticleHovered(true);
    }
    if (isHoveringMovie) {
      updateMovieHovered(true);
    }
  }, [isHoveringArticle, isHoveringMovie]);

  useMount(() => {
    activeNav(setActive);
    if (!onlineData?.modelCount) {
      getOnlineData();
    }
  });


  const intervalDuration = (duration) => {
    let dur = duration;
    const setTimeDuration = setInterval(() => {
      dur--;
      if (dur <= 0) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        setTimeDuration && clearInterval(setTimeDuration);
        intervalDuration(duration.length);
      }
      setPlaceholder(duration[dur]);
    }, 5000);
  }

  useEffect(() => {
    if (Array.isArray(keyword) && keyword.length > 0) {
      const texts = keyword.map((item: any) => item.text).reverse();
      let index = 0;
  
      setPlaceholder(texts[index]);
  
      const interval = setInterval(() => {
        index = (index + 1) % texts.length;
        setPlaceholder(texts[index]);
      }, 5000);
  
      return () => clearInterval(interval);
    }
    return () => { }
  }, [keyword]);


  const isPkCheckedMap = useMemo(() => {
    const checkedList = globalPkList.filter((item: any) => item.isChecked).map((item: any) => item.myid) || [];
    return new Set(checkedList);
  }, [globalPkList]);

  return (
    <div className='w-full relative h-80 flex items-center bg-[#F8F9FC] z-[999]'>
      <div
        className='pl-24 min-w-[1480px] w-full flex items-center justify-between fixed top-0 left-0 h-80'
        id='SinglePageNav'
        style={{ background: "linear-gradient(275deg,rgba(255,255,255,0.00) 4%, #ffffff 97%)" }}
      >
        <picture>
          <source srcSet={'https://photo.8891.com.tw/2024/11/07/1730964358639012.png'} type="image/png" />
          <img
            src={'https://photo.8891.com.tw/2024/11/07/1730964358639012.png'}
            className='w-full h-full object-cover absolute top-0 left-0'
            alt={'8891'}
            width={'100%'}
            height={'100%'}
            loading="eager"
            {...({ fetchPriority: "high" } as any)}
          />
        </picture>

        <div className='flex items-center justify-start relative h-full flex-1 pr-30'>
          <a href={`${c}`}>
            <img
              src='https://photo.8891.com.tw/2024/05/21/1716274778529383.png'
              width={148}
              height={32}
              style={{ objectFit: "contain" }}
              alt="8891新車"
            />
          </a>

          <div className='flex justify-start items-center flex-1 pl-30 h-full min-w-[620px] max-w-[620px] w-[620px]'>
            <a
              id='nav_0'
              className={`text-20 mr-30 block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${active === 0 ? "text-[#3264FF]" : "text-[#333]"
                }`}
              href={`${c}/Models`}
              target='_blank'
            >
              找汽車
            </a>
            {/* <a
              id='nav_1'
              className={`text-20 mr-30 block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${active === 1 ? "text-[#3264FF]" : "text-[#333]"
                }`}
              href={`${c}/buyCar`}
              target='_blank'
            >
              買新車
            </a> */}
            <a
              className={`text-20 mr-30 relative block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${active === 6 ? "text-[#3264FF]" : "text-[#333]"
                }`}
              href={`${c}/menu`}
              target='_blank'
              onClick={() => { }}
            >
              購車菜單
              <span
                className='w-full h-16 absolute -right-28 -top-12 text-[#fff] text-12 font-normal text-center'
                style={{
                  background: "linear-gradient(180deg,#ff4b40, #ff3030)",
                  borderRadius: "50px 50px 50px 0px",
                  lineHeight: "16px",
                }}
              >
                最新成交價
              </span>
            </a>
            <div ref={articleRef}>
              <a
                id='newTopNav3'
                className={`text-20 mr-30  block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${active === 2 ? "text-[#3264FF]" : "text-[#333]"
                  }`}
                href={`${c}/Articles`}
                target='_blank'
              >
                文章
              </a>
              <div className={`${isHoveringArticle ? "flex" : "none"}`}>
                {<ArticlePopover isMount={articleHovered} />}
              </div>
            </div>

            <div ref={movieRef}>
              <a
                id='newTopNav4'
                className={`text-20 mr-30  block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${active === 3 ? "text-[#3264FF]" : "text-[#333]"
                  }`}
                href={`${c}/movies`}
                target='_blank'
              >
                影音
                <div className={`${isHoveringMovie ? "flex" : "hidden"}`}>
                  {<MoviePopover isMount={movieHovered} />}
                </div>
              </a>
            </div>

            <a
              id='newTopNav5'
              className={`text-20 mr-30  block h-32 cursor-pointer leading-32 relative hover:text-[#3264FF] ${active === 4 ? "text-[#3264FF]" : "text-[#333]"
                }`}
              href={`${c}/photoModel-compare.html?myids=${Array.from(isPkCheckedMap).join(",")}`}
              target='_blank'
            >
              比較
              <span
                className='w-22 h-16 absolute -right-4 -top-12 text-[#fff] text-12 font-normal text-center'
                style={{
                  background: "linear-gradient(180deg,#ff4b40, #ff3030)",
                  borderRadius: "50px 50px 50px 0px",
                  lineHeight: "16px",
                }}
              >
                新
              </span>
            </a>
            <a
              id='newTopNav6'
              className={`text-20 mr-30  block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${active === 5 ? "text-[#3264FF]" : "text-[#333]"
                }`}
              href={`${c}/sales/top`}
              target='_blank'
            >
              排行榜
            </a>
          </div>

          <div className='w-full'>
            <div
              id='tracking-search'
              className='min-w-[140px] max-w-[400px] w-full h-40 leading-40 text-14 cursor-pointer rounded-4 pl-8 text-[#999] bg-white line-clamp-1'
              style={{ boxShadow: "0px 2px 18px 0px rgba(0,0,0,0.10)" }}
              onClick={() => {
                setShowSearch(true);
                const item = !!keyword.length && (keyword as any).find((item: any) => item.text === placeholder);
                item.ads && postInitialCollect(item.ads, "click");
                document.body.setAttribute("style", "overflow: hidden");
              }}
            >
              <img
                src='https://photo.8891.com.tw/2024/11/07/1730958164596034.png'
                width={14}
                height={14}
                className='mr-6'
                alt="搜尋"
              />
              {(!!placeholder && placeholder.trim()) || <>搜尋</>}
            </div>
          </div>
        </div>

        <div className='flex items-center gap-30 mr-30 h-80 z-[10]'>
          <a
            href={`${www}`}
            target='_blank'
            className='flex items-center gap-4 text-[#1D2029] text-14 cursor-pointer hover:text-[#3264FF]'
          >
            <img src='https://photo.8891.com.tw/2024/11/07/1730958611871241.png' width={14} height={14} />
            8891汽車首頁
          </a>
          <div className='tc-top-nav-right-item h-full flex items-center'>
            <UserPopover />
          </div>
          <div className='tc-top-nav-right-item h-full flex items-center'>
            <a
              className='tc-top-nav-right-link flex items-center gap-4 text-[#1D2029] text-14 m-0'
              href={`${www}/help-index.html`}
              target='_blank'
            >
              <img src='https://photo.8891.com.tw/2024/11/07/1730958611649528.png' width={14} height={14} />
              幫助
            </a>
            <HelpPopover />
          </div>

          <div className='tc-top-nav-right-item h-full flex items-center'>
            <a className='tc-top-nav-right-link flex items-center gap-4 text-[#1D2029] text-14 m-0'>
              <img src='https://photo.8891.com.tw/2024/11/07/1730958611619555.png' width={14} height={14} />
              APP下載
            </a>
            <AppPopover />
          </div>
        </div>

        <SearchPopover
          visible={showSearch}
          type={"default"}
          isFixed={false}
          toggle={() => {
            setShowSearch(false);
            document.body.removeAttribute("style");
          }}
        />
      </div>
    </div>
  );
};

export default SinglePageNav;
